// AI Generated Component
import { Component, Input, OnInit, OnChanges, OnDestroy, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { ChangesHistoryDashboardService } from './dashboard.service';
import { PropertiesSumService } from '@client/app/filters/properties-sum.service';

@Component({
    selector: 'changes-history-dashboard',
    standalone: false,
    template: `
<div class="changes-history-dashboard">
    <div class="card panel-monsido-card">
        <div class="card-body pt-0 pb-3">
            <div class="row" [hidden]="domain?.id && selectedModule">
                <div class="col-48 text-center pt-6 pb-4">
                    <img class="img-responsive center-block"
                         [src]="'/images/change-history/select-domain-and-module.png'"
                         [attr.alt]="'Scan History' | translate"/>
                    <br/>
                    <p translate class="mt-7 font-weight-500 font-size-1-5">Select Domain and Module to get the Insights</p>
                </div>
            </div>
            <div *ngIf="!showScores" class="row statistics-summary mt-0" [hidden]="!domain?.id || !selectedModule">
                <div class="col-16 py-2 statistics-card" *ngIf="showTotalContentFlag">
                    <div class="ml-4">
                        <div class="outer-b-smurf font-size-1-1 font-weight-500" translate>
                            Total amount of content
                        </div>
                        <div class="outer-t-smurf mb-1 font-size-175 font-weight-500">
                            {{pageStackEndValue | monNumber}}
                        </div>
                        <span class="mt-0">
                            <span class="fas font-size-0-9 mr-1 mt-1"
                                  *ngIf="pageStackChangeValue !== 0"
                                  [class.fa-chevron-down]="pageStackStartValue > pageStackEndValue"
                                  [class.fa-chevron-up]="pageStackStartValue < pageStackEndValue">
                            </span>
                            <span>{{pageStackChangeValue/100 | monNumber:'0.[00]%'}}</span>
                        </span>
                    </div>
                </div>
                <div class="col-16 py-2 statistics-card" *ngIf="showIssuesSummaryFlag">
                    <div class="ml-4">
                        <div class="outer-b-smurf font-size-1-1 font-weight-500">
                            <span translate>Content with issues</span>
                            <span class="fas fa-question-circle hidden-print"
                                  [triggers]="'focus hover'"
                                  [ngbTooltip]="issuesTooltip">
                            </span>
                        </div>
                        <div class="outer-t-smurf mb-1 font-size-175 font-weight-500">
                            {{pagesStackByModuleEndValue | monNumber}}
                        </div>
                        <span class="mt-0"
                            [class.text-success]="pagesStackByModuleStartValue > pagesStackByModuleEndValue"
                            [class.text-danger]="pagesStackByModuleStartValue < pagesStackByModuleEndValue"
                            [class.text-grey]="pagesStackByModuleStartValue === pagesStackByModuleEndValue">
                            <span class="fas font-size-0-9 mr-1 mt-1"
                                  *ngIf="pagesStackByModuleChangeValue !== 0"
                                  [class.fa-chevron-down]="pagesStackByModuleStartValue > pagesStackByModuleEndValue"
                                  [class.fa-chevron-up]="pagesStackByModuleStartValue < pagesStackByModuleEndValue">
                            </span>
                            <span>{{pagesStackByModuleChangeValue/100 | monNumber:'0.[00]%'}}</span>
                        </span>
                    </div>
                </div>
                <div class="col-16 py-2 statistics-card" *ngIf="showIssuesSummaryFlag">
                    <div class="ml-4">
                        <div class="outer-b-smurf font-size-1-1 font-weight-500">
                            {{'Total number of issues' | translate }}
                            <span class="fas fa-question-circle hidden-print"
                                  [triggers]="'focus hover'"
                                  [ngbTooltip]="totalIssuesTooltip">
                            </span>
                        </div>
                        <div class="outer-t-smurf mb-1 font-size-175 font-weight-500">
                            {{issuesStackEndValue | monNumber}}
                        </div>
                        <span class="mt-0"
                            [class.text-success]="issuesStackStartValue > issuesStackEndValue"
                            [class.text-danger]="issuesStackStartValue < issuesStackEndValue"
                            [class.text-grey]="issuesStackStartValue === issuesStackEndValue">
                            <span class="fas font-size-0-9 mr-1 mt-1"
                                  [hidden]="issuesStackChangeValue === 0"
                                  [class.fa-chevron-down]="issuesStackStartValue > issuesStackEndValue"
                                  [class.fa-chevron-up]="issuesStackStartValue < issuesStackEndValue">
                            </span>
                            <span>{{issuesStackChangeValue/100 | monNumber:'0.[00]%'}}</span>
                        </span>
                    </div>
                </div>
                <div class="col-32 py-2 statistics-card" *ngIf="selectedModule === 'readability'">
                    <changes-history-dashboard-summary-readability [history]="history"
                                                                   [domain]="domain"
                                                                   [total]="pageStackEndValue">
                    </changes-history-dashboard-summary-readability>
                </div>
                <div class="col-48 py-2 statistics-card" *ngIf="selectedModule === 'performance'">
                    <changes-history-dashboard-summary-performance [history]="history"
                                                                   [domain]="domain">
                    </changes-history-dashboard-summary-performance>
                </div>
            </div>
            <mon-spinner [progress]="progress" [loading]="loading">
                <div class="row break-after"
                     [class.outer-t-xlarge]="!hasAttributeWithNameFlag"
                     [class.merge-t-44]="hasAttributeWithNameFlag"
                     [style.display]="domain?.id && selectedModule ? 'block' : 'none'">
                    <div *ngIf="!showScores" class="col-48 text-center hidden-print">
                        <div class="btn-group" role="group">
                            <button type="button"
                                    [attr.aria-labelledby]="'group_option_' + i"
                                    class="btn btn-border-radius btn-secondary outer-b-large"
                                    [class.active]="selectedGroupOption === option.value"
                                    (click)="selectGroupOption(option.value)"
                                    *ngFor="let option of groupOptions; let i = index; trackBy: trackByIndex"
                                    [hidden]="option.belongsTo !== selectedModule">
                                {{option.name}}
                                <span [id]="'group_option_' + i" class="sr-only" translate [translate-args]="{name: option.name}">
                                    Chart is now showing: [[name]]
                                </span>
                            </button>
                        </div>
                    </div>
                    <div *ngIf="!showScores" class="col-48 px-6 avoid-page-break">
                        <mon-chart-line *ngIf="!loading"
                                    [labels]="labels"
                                    [override]="override"
                                    [data]="data"
                                    [series]="series"
                                    [height]="'300'"
                                    [colors]="colors"
                                    [options]="options"
                                    [emptyDataMessage]="'No historic data available for this domain' | translate">
                        </mon-chart-line>
                    </div>
                    <div *ngIf="showScores" class="col-48 px-6 avoid-page-break">
                        <mon-chart-line *ngIf="!loading"
                                    [labels]="scoreLabels"
                                    [override]="scoresChartOverride"
                                    [data]="scoresChartData"
                                    [series]="scoresChartSeries"
                                    [height]="300"
                                    [colors]="scoresChartColors"
                                    [options]="scoresChartOptions"
                                    [emptyDataMessage]="'No scores available for this domain' | translate">
                        </mon-chart-line>
                    </div>
                </div>

                <div class="row mt-9 avoid-page-break" *ngIf="domain?.id">
                    <hr class="visible-print-block my-0"/>
                    <div class="col-48 mt-6">
                        <table-container [collection]="history"
                                         [progress]="progress"
                                         [noResultMessage]="'No historic data available for this domain' | translate">
                            <div>
                                <changes-history-dashboard-table-change-history [domain]="domain"
                                                                                [history]="history"
                                                                                *ngIf="selectedModule === 'all'">
                                </changes-history-dashboard-table-change-history>
                                <changes-history-dashboard-table-seo [history]="history"
                                                                     [domain]="domain"
                                                                     [domainGroup]="domainGroup"
                                                                     *ngIf="selectedModule === 'seo'">
                                </changes-history-dashboard-table-seo>
                                <changes-history-dashboard-table-policy [history]="history"
                                                                        [domain]="domain"
                                                                        *ngIf="selectedModule === 'policy'">
                                </changes-history-dashboard-table-policy>
                                <changes-history-dashboard-table-qa [history]="history"
                                                                    [domain]="domain"
                                                                    *ngIf="selectedModule === 'qa'">
                                </changes-history-dashboard-table-qa>
                                <changes-history-dashboard-table-accessibility [domain]="domain"
                                                                               [history]="history"
                                                                               [domainGroup]="domainGroup"
                                                                               *ngIf="selectedModule === 'accessibility'">
                                </changes-history-dashboard-table-accessibility>
                                <changes-history-dashboard-table-readability [domain]="domain"
                                                                             [history]="history"
                                                                             *ngIf="selectedModule === 'readability'">
                                </changes-history-dashboard-table-readability>
                                <changes-history-dashboard-table-data-privacy [domain]="domain"
                                                                              [history]="history"
                                                                              [domainGroup]="domainGroup"
                                                                              *ngIf="selectedModule === 'data-privacy'">
                                </changes-history-dashboard-table-data-privacy>
                                <changes-history-dashboard-table-performance [domain]="domain"
                                                                             [history]="history"
                                                                             [domainGroup]="domainGroup"
                                                                             *ngIf="selectedModule === 'performance'">
                                </changes-history-dashboard-table-performance>
                            </div>
                        </table-container>
                    </div>
                </div>
            </mon-spinner>
        </div>
    </div>
</div>
    `,
})
export class ChangesHistoryDashboardComponent implements OnInit, OnChanges, OnDestroy {
    @Input() domain!: any;
    @Input() selectedModule!: any;
    @Input() progress!: any;
    @Input() loading!: any;
    @Input() selectedGroupOption!: any;
    @Input() domainGroup!: any;
    @Input() showScores!: any;

    @Output() selectedGroupOptionChange = new EventEmitter<any>();
    @Output() setupLineChart = new EventEmitter<any>();

    private onDestroy$ = new Subject<void>();

    showIssuesSummaryFlag = false;
    hasAttributeWithNameFlag = false;
    showTotalContentFlag = false;
    modulesWithoutIssuesSummary = ['readability', 'performance'];
    modulesWithoutTotalContent = ['performance'];

    issuesTooltip: any;
    totalIssuesTooltip: any;
    pageStackStartValue: any;
    pageStackEndValue: any;
    pageStackChangeValue: any;
    issuesStackStartValue: any;
    issuesStackEndValue: any;
    issuesStackChangeValue: any;
    pagesStackByModuleStartValue: any;
    pagesStackByModuleEndValue: any;
    pagesStackByModuleChangeValue: any;
    history: any[] = [];

    override: any = {};
    series: any[] = [];
    colors: any[] = [];
    labels: any[] = [];
    data: any[] = [];
    options: any = {};
    pagesStack: any[] = [];
    pagesStackByModule: any[] = [];
    issuesStack: any[] = [];
    scoresChartData: any[] = [];
    scoresChartSeries: any[] = [];
    scoreLabels: any[] = [];
    scoresChartOverride: any;
    scoresChartColors: any[] = [];
    scoresChartOptions: any = {};
    groupOptions: any[] = [];

    constructor (
        private translateService: TranslateService,
        private changesHistoryDashboardService: ChangesHistoryDashboardService,
        private propertiesSumService: PropertiesSumService,
    ) {}

    ngOnInit (): void {
        this.selectedGroupOption = this.selectedGroupOption || null;
        this.override = {};
        this.series = [];
        this.colors = [];
        this.labels = [];
        this.data = [];
        this.options = {};
        this.pagesStack = [];
        this.pagesStackByModule = [];
        this.issuesStack = [];
        this.scoresChartData = [];
        this.scoresChartSeries = [];

        this.changesHistoryDashboardService.pagesStack$.pipe(
            takeUntil(this.onDestroy$),
        ).subscribe((pageStack) => {
            this.pagesStack = pageStack;
            this.updatePageStack();
        });

        this.changesHistoryDashboardService.history$.pipe(
            takeUntil(this.onDestroy$),
        ).subscribe((data) => {
            this.history = data;
            this.updateNumbers();
            this.setupData();
            this.updatePageStack();
        });
        this.setupWatchers();
    }

    ngOnChanges (changes: SimpleChanges): void {
        if (changes.selectedModule) {
            this.updateNumbers();
        }

        if (changes.showScores) {
            this.setupData();
        }
    }

    ngOnDestroy (): void {
        this.onDestroy$.next();
        this.onDestroy$.complete();
    }

    private setupWatchers (): void {
        this.changesHistoryDashboardService.chartChangeObs.subscribe(() => this.setupData());
    }

    selectGroupOption (selectedGroup: any): void {
        this.changesHistoryDashboardService.setGroupOption(selectedGroup);
    }

    private getChangeValue (arrayValues: any[]): any {
        const end = this.propertiesSumService.sum(this.history[0], arrayValues);
        const start = this.propertiesSumService.sum(this.history[this.history.length - 1], arrayValues);
        return this.getChange(start, end);
    }

    private getStartValue (arrayValues: any[]): any {
        return this.propertiesSumService.sum(this.history[0], arrayValues);
    }

    private getEndValue (arrayValues: any[]): any {
        return this.propertiesSumService.sum(this.history[this.history.length - 1], arrayValues);
    }

    private getIssuesStack (): any[] {
        let issues: any[] = [];

        if (this.selectedModule === 'accessibility' || this.selectedModule === 'all') {
            issues = issues.concat(['accessiblity_issues_count']);
        }

        if (this.selectedModule === 'seo' || this.selectedModule === 'all') {
            issues = issues.concat(['seo_errors_alerts_count', 'seo_errors_warnings_count', 'seo_errors_infos_count']);
        }

        if (this.selectedModule === 'qa' || this.selectedModule === 'all') {
            issues = issues.concat(['dead_links_count', 'dead_images_count', 'spelling_errors_confirmed_count']);
        }

        if (this.selectedModule === 'policy' || this.selectedModule === 'all') {
            issues = issues.concat(['policy_with_violations_count', 'policy_with_required_count']);
        }

        if (this.selectedModule === 'data-privacy') {
            issues = ['data_protection_violations_count'];
        }

        return issues;
    }

    private getTotalIssuesTooltip (): string {
        switch (this.selectedModule) {
            case 'accessibility':
                return this.translateService.getString('Accessibility checks not in compliance with domain');
            case 'seo':
                return this.translateService.getString('Contains high, medium or low opportunities');
            case 'qa':
                return this.translateService.getString('Contains confirmed misspellings, broken links or images');
            case 'policy':
                return this.translateService.getString('Policies marked as required or unwanted');
            default:
                return this.translateService.getString('Total number of issues across all modules');
        }
    }

    private getIssuesTooltip (): string {
        switch (this.selectedModule) {
            case 'accessibility':
                return this.translateService.getString('Pages with accessibility checks not in compliance');
            case 'seo':
                return this.translateService.getString('Pages with high, medium or low opportunities');
            case 'qa':
                return this.translateService.getString('Pages & documents with confirmed misspellings, broken links or images');
            case 'policy':
                return this.translateService.getString('Pages and documents with policies marked as unwanted or required');
            case 'data-privacy':
                return this.translateService.getString('Pages with Data Privacy violations');
            default:
                return this.translateService.getString('Summarized pages and documents count');
        }
    }

    private getPagesStackByModule (): any[] {
        switch (this.selectedModule) {
            case 'accessibility':
                return ['pages_with_accessibility_errors_count'];
            case 'seo':
                return ['pages_with_seo_errors_count'];
            case 'qa':
                return ['pages_with_notifications_count'];
            case 'policy':
                return ['pages_with_policy_matches_count'];
            case 'readability':
                return ['pages_count', 'documents_count'];
            case 'data-privacy':
                return ['data_protection_pages_with_violations_count'];
            case 'performance':
                return ['performance_page_count'];
            default:
                return ['pages_with_errors_count'];
        }
    }

    private checkHasAttributeWithName (collection: any[], param: string, val: any): boolean {
        for (let i = 0; i < collection.length; i++) {
            if (collection[i][param] === val) {
                return true;
            }
        }
        return false;
    }

    private getChange (start: any, end: any): number {
        if (typeof start !== 'number' || typeof end !== 'number') {
            return 0;
        }
        const highestNumber = Math.max(start, end);
        const lowestNumber = Math.min(start, end);
        return 100 - (lowestNumber / highestNumber) * 100 || 0;
    }

    private setupData (): void {
        this.scoresChartData = [];
        this.groupOptions = this.changesHistoryDashboardService.getGroupOptions();
        this.selectedGroupOption = this.changesHistoryDashboardService.getDefaultGroupOption();

        if (this.showScores) {
            this.setupScoresChart();
        } else {
            this.setupChartData();
        }

        this.updatePageStack();

        if (this.issuesStack.length) {
            this.issuesStackStartValue = this.getStartValue(this.issuesStack);
            this.issuesStackEndValue = this.getEndValue(this.issuesStack);
            this.issuesStackChangeValue = this.getChangeValue(this.issuesStack);
        }

        if (this.pagesStackByModule.length) {
            this.pagesStackByModuleStartValue = this.getStartValue(this.pagesStackByModule);
            this.pagesStackByModuleEndValue = this.getEndValue(this.pagesStackByModule);
            this.pagesStackByModuleChangeValue = this.getChangeValue(this.pagesStackByModule);
        }

        if (this.selectedModule) {
            this.hasAttributeWithNameFlag = this.checkHasAttributeWithName(this.groupOptions, 'belongsTo', this.selectedModule) && !this.showScores;
        }
    }

    private updatePageStack (): void {
        if (this.history && this.history.length && this.pagesStack && this.pagesStack.length) {
            this.pageStackStartValue = this.getStartValue(this.pagesStack);
            this.pageStackEndValue = this.getEndValue(this.pagesStack);
            this.pageStackChangeValue = this.getChangeValue(this.pagesStack);
        }
    }

    private checkShowIssuesSummary (module: string): boolean {
        return this.modulesWithoutIssuesSummary.indexOf(module) === -1;
    }

    private checkShowTotalContent (module: string): boolean {
        return this.modulesWithoutTotalContent.indexOf(module) === -1;
    }

    private setupChartData (): void {
        this.colors = this.changesHistoryDashboardService.getColors();
        this.override = this.changesHistoryDashboardService.getOverride();
        this.labels = this.changesHistoryDashboardService.getLabels();
        this.changesHistoryDashboardService.getOptions().then((options) => {
            this.options = options;
            this.series = this.changesHistoryDashboardService.getSeries();
            this.data = this.changesHistoryDashboardService.getData();
        }, () => {});
    }

    private setupScoresChart (): void {
        this.scoresChartData = [
            this.changesHistoryDashboardService.getProcessedScoresData(this.selectedModule, this.history),
            this.changesHistoryDashboardService.getVerticalScores(this.selectedModule, this.history),
        ];
        this.scoresChartOptions = this.changesHistoryDashboardService.getScoresChartOptions();
        this.scoreLabels = this.changesHistoryDashboardService.getLabels();
        this.scoresChartSeries = this.changesHistoryDashboardService.getScoresChartSeries(this.selectedModule);
        this.scoresChartColors = this.changesHistoryDashboardService.getScoresChartColors();
        this.scoresChartOverride = this.changesHistoryDashboardService.getScoresChartOverride();
    }

    private updateNumbers (): void {
        this.issuesStack = this.getIssuesStack();
        this.pagesStackByModule = this.getPagesStackByModule();
        this.totalIssuesTooltip = this.getTotalIssuesTooltip();
        this.issuesTooltip = this.getIssuesTooltip();
        this.showIssuesSummaryFlag = this.checkShowIssuesSummary(this.selectedModule);
        this.showTotalContentFlag = this.checkShowTotalContent(this.selectedModule);
    }

    trackByIndex (index: number): number {
        return index;
    }
}
